import Swiper from "swiper/core"

const articleFeaturedProducts = {
  fetchProducts() {
    let self = this;

    if (!document.querySelector('#article_variant_skus')) {
      return;
    }
 
    let skusQuery = document.querySelector('#article_variant_skus').innerHTML;
    let skusArray = skusQuery.split(',');
    skusArray = skusArray.slice(0, 8);
    skusQuery = skusArray.join(' OR ');

    if (skusQuery) {
      fetch("/search.json?q=" + skusQuery + "&view=article-products")
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        const resultHTML = new DOMParser().parseFromString(html, 'text/html');
        const hasResults = resultHTML.querySelector('#article_products_search_results');
        if (hasResults){
          document.querySelector('.articleProducts__results').innerHTML = resultHTML.querySelector('#article_products_search_results').outerHTML;
          document.querySelector('.article__products').classList.remove('hidden');
        } else {
          document.getElementById('articleMain').style.gridColumn ='span 4 / span 4';
          document.getElementById('articleMain').style.paddingRight ='0';
        }
        setTimeout(function() {
          self.initSticky()
          self.initGallery()
        }, 400);
      }).catch((err) => {
        console.log('Something went wrong.', err);
      });
    }
  },

  getOffset(ele) {
    var rect = ele.getBoundingClientRect();
    return {
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX
    }
  },

  initSticky() {
    if (window.innerWidth > 1024) {
      this.toggleSticky();

      window.addEventListener("scroll", () => {
        this.toggleSticky();  
      })
    } else {
      document.querySelector('#article_products').classList.remove('fixed');
      document.querySelector('#article_products').removeAttribute('style');
      window.addEventListener("scroll", () => {
        document.querySelector('#article_products').classList.remove('fixed');
        document.querySelector('#article_products').removeAttribute('style');
      })
    }
  },

  toggleSticky() {
    const mainSection = document.querySelector('.article__mainInner');
    const sidebarSection = document.querySelector('#article_products');
    const top = this.getOffset(mainSection).top;
    const bottom = this.getOffset(mainSection).top + mainSection.offsetHeight;
    const headerSection = document.querySelector('.navigation.fixed');

    if (mainSection.offsetHeight <= sidebarSection.offsetHeight + 48) {
      sidebarSection.classList.remove('fixed');
      sidebarSection.removeAttribute('style');
      return;
    }

    if (!headerSection) {
      sidebarSection.classList.remove('fixed');
      sidebarSection.removeAttribute('style');
      return;
    }


    const maxY = bottom - sidebarSection.offsetHeight;
    const y = document.scrollingElement.scrollTop;

    if (y < maxY) {
      sidebarSection.classList.add("fixed")
      sidebarSection.setAttribute('style', 'top: '+(headerSection.offsetHeight + 10)+'px');
    } else {
      sidebarSection.classList.remove("fixed")
      sidebarSection.setAttribute('style', 'position: absolute; top: '+(maxY - top)+'px');
    }
  },

  initGallery() {
    const gallery = document.querySelector('.articleProducts__results').swiper;
    const slides = document.querySelectorAll('.articleProduct');

    if (window.innerWidth <= 1024) {
      slides.forEach(slide => {
        slide.classList.add('swiper-slide')
      })
      return new Swiper('.articleProducts__results', {
        slidesPerView: 2,
        spaceBetween: 12,
        pagination: {
          el: ".article__products .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 4
          }
        }
      });
    } else {
      if (gallery){
        gallery.destroy();
        slides.forEach(slide => {
          slide.classList.remove('swiper-slide')
        })
      }
    }
  },
  onResize(){
    addEventListener('resize', () => {
      this.initSticky();
      this.initGallery();
    });
  },

  init() {
    this.fetchProducts()
    this.onResize()
  }
}

export default articleFeaturedProducts
